import clsx from "clsx";
import Link from "next/link";
import Image from "next/image";

import Button from "../button";

import styles from "./featured-options-section.module.scss";

const OptionListItem = ({ option }) => {
  return (
    <div className={styles.OptionListItem}>
      <div className={styles.ImageWrapper}>
        <Image
          src={`${option.image.url}?w=225&fm=webp&q=80`}
          width="225"
          height="225"
          layout="responsive"
          objectFit="cover"
          alt={option.name}
        />
      </div>
      <div className={styles.OptionContent}>
        <h3>{option.name}</h3>
        <p>{option.locationsCollection.items[0].name}</p>

        <Link href={`/options/${option.slug}`} passHref>
          <a>View Details</a>
        </Link>
      </div>
    </div>
  );
};

const FeaturedOptionsSection = ({ options = {} }) => {

  return (
    <div className={styles.FeaturedOptionsSection}>
      <div className={clsx("container", styles.Wrapper)}>
        <div className={styles.Content}>
          <h3>{options.title}</h3>
          <p>{options.description}</p>

          <Link href="/solutions" passHref>
            <Button outline small rounded className={styles.DesktopButton}>
              View All Solutions
            </Button>
          </Link>
        </div>
        <div className={styles.OptionsList}>
          {options?.featuredOptionsCollection?.items?.map((option) => (
            <OptionListItem key={option.slug} option={option} />
          ))}
        </div>

        <div className={styles.MobileButton}>
          <Link href="/solutions" passHref>
            <Button outline small rounded>
              View All Solutions
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FeaturedOptionsSection;
